import { render, staticRenderFns } from "./detail-info-file-list.vue?vue&type=template&id=2a48a9f0&scoped=true&"
import script from "./detail-info-file-list.vue?vue&type=script&lang=js&"
export * from "./detail-info-file-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-info-file-list.vue?vue&type=style&index=0&id=2a48a9f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48a9f0",
  null
  
)

export default component.exports